import React from 'react';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { Button, ButtonProps } from 'evergreen-ui';
import { NEW } from 'Features/routePaths';
import { canCreateStationSelector } from 'Services/auth.service';
import { getStationPath } from './utils';

function InternalCreateStationButton(props: ButtonProps) {
  const canCreateStation = useSelector(canCreateStationSelector);
  if (!canCreateStation) return null;
  return (
    <Button
      is={Link}
      // @ts-ignore
      to={getStationPath(NEW)}
      intent="success"
      appearance="primary"
      lineHeight="1rem"
      minHeight="max-content"
      {...props}
    >
      Создать станцию
    </Button>
  );
}
export const CreateStationButton = React.memo(InternalCreateStationButton);
CreateStationButton.displayName = 'CreateStationButton';
export default CreateStationButton;
